
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { usePipelinesStore } from '@/store/pipelines/pipelines.store';
import { useFormContext } from 'react-hook-form'

const DealStatusField = () => {
    const useFormReturn = useFormContext();
    const { control, setValue, clearErrors, watch } = useFormReturn;
    const pipelines = usePipelinesStore((s) => s.entities);
    const { pipeline, status } = watch();
    const selectedPipeline = pipeline ? pipelines[pipeline] : null;
    const statusList = selectedPipeline?.status || [];
    const isPipelineSelected = !!pipeline;

    return (
        <FormField
            control={control}
            name="status"
            render={() => (
                <FormItem>
                    <FormLabel className="mb-2 block text-[10.5px] font-medium uppercase tracking-[0.12em] text-slate-500">
                        Status <span className="text-accent-red">*</span>
                    </FormLabel>
                    <FormControl>
                        <Select
                            disabled={!isPipelineSelected}
                            onValueChange={(v) => {
                                setValue("status", Number(v), { shouldDirty: true });
                                clearErrors("status");
                            }}
                            value={status ? `${status}` : ""}
                        >
                            <SelectTrigger className="h-9 rounded-lg border-white/[0.08] bg-white/[0.02] text-[12.5px] text-slate-200 disabled:cursor-not-allowed disabled:opacity-50">
                                <SelectValue placeholder={isPipelineSelected ? "Choose status" : "Select pipeline first"} />
                            </SelectTrigger>
                            <SelectContent className="rounded-xl border-white/[0.08] bg-ink-800/95 text-slate-200 shadow-card backdrop-blur-xl">
                                <SelectGroup>
                                    {statusList.map((status) => (
                                        <SelectItem
                                            key={status.id}
                                            value={`${status.id}`}
                                            className="text-[12.5px]"
                                        >
                                            <span className="flex items-center gap-2">
                                                <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ background: status.color }} />
                                                {status.name}
                                            </span>
                                        </SelectItem>
                                    ))}
                                </SelectGroup>
                            </SelectContent>
                        </Select>
                    </FormControl>
                    <FormMessage className="text-[10.5px] text-accent-red" />
                </FormItem>
            )}
        />
    )
}

export default DealStatusField
